function fetchResults(id, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/availability/${id}`;
  return apiClient.get(route);
}

export default {
  fetchResults
};
